import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Panel, TitleArray} from '../../../core/interfaces/library-v2-data.i';
import { Router } from '@angular/router';
import { AidemosService } from '../../../modules/details-page/services/aidemos/aidemos.service';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { DetailsService } from 'src/app/modules/details-page/services/details.service';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics-service/google-analytics.service';

enum EVideoAction {
  play,
  pause,
  complete
}

@Component({
  selector: 'app-ai-demos',
  templateUrl: './ai-demos.component.html',
  styleUrls: ['./ai-demos.component.scss']
})
export class AiDemosComponent implements OnInit, OnDestroy {
  isAI: boolean = false;
  aiSub: boolean = false;
  @Input() panelData: any;
  isPantherLakeStd: boolean = false;
  isPantherLakeStdxe: boolean = false;
  isRedesign: boolean = false;
  aiDemosHomeIcon: string = GlobalConstants.HOME_ICON;
  language: string = '';
  aiDemoTitleArray: any;
  availableFilters: any;
  filteredPanelData: any;
  selectedFilters: string[] = [];
  panelAiData: any;
  videoLink: string = '';
  @ViewChild('AIModal') AIModal: TemplateRef<any>;
  EVideoAction = EVideoAction;
  endAi: boolean = false;
  closeIcon: string = '';
  filterCloseIcon: string = '';
  isWildCatLakeStd: boolean= false;
  aiDemoArray: any;
  wclArrowUrl="assets/images/wcl-explore-arrow.svg"
  constructor(
    private aidemosService: AidemosService,
    private qrCodeService: QrCodeService,
    private router: Router,
    private modalService: NgbModal,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.language = this.qrCodeService.language;
    const fontDirectionEl = document.getElementById('fontDirection');
    if (fontDirectionEl) {
      fontDirectionEl.classList.add('hide-scrollbar');
    }
    this.aiDemoArray = this.aidemosService.getAIDemosData();
    this.isPantherLakeStd = this.qrCodeService?.isPantherLakeStd;
    this.isPantherLakeStdxe = this.qrCodeService?.isPantherLake12Xe;
    this.isWildCatLakeStd=this.qrCodeService.isWildCatLakeStd;
    if (this.isWildCatLakeStd) {
    this.aiDemoTitleArray=this.aiDemoArray.filter(ele=>ele.processorType===GlobalConstants.WILDCAT_LAKE)
    this.closeIcon = this.aiDemoTitleArray[0]?.badgeUrl;
    this.filterCloseIcon = this.aiDemoTitleArray[0]?.tileBadgeUrl;
    const categories: any[] =this.aiDemoTitleArray[0]?.aiDemoCategory || [];
    this.availableFilters = categories.map(category => ({ key: category.category, value: category.tr_tile }));
    this.filterPanelData();
    }
    else{
      this.aiDemoTitleArray=this.aiDemoArray.filter(ele=>ele.processorType===GlobalConstants.PANTHER_LAKE)
      this.closeIcon = this.aiDemoTitleArray[0]?.badgeUrl;
      if (this.isPantherLakeStd)
        this.filterCloseIcon = this.aiDemoTitleArray[0]?.tileBadgeUrl;
      else
        this.filterCloseIcon = GlobalConstants.PTL_12XE_FILTER_CLOSE_ICON;
      const categories: any[] = this.aiDemoTitleArray[0]?.aiDemoCategory || [];
      this.availableFilters = categories.map(category => ({ key: category.category, value: category.tr_tile }));
      this.filterPanelData();
    }
   
   
  }
  routeToTileDetailsPage(tileUrl: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/specs/' + tileUrl]);
    });
  }

  toggleFilter(filterKey: string): void {
    if (this.availableFilters?.length > 0) {
      const filter = this.availableFilters.find((filter: any) => filter.key === filterKey);
      if (!filter) { return; }
      if (this.selectedFilters.includes(filterKey)) {
        this.selectedFilters = [];
      } else {
        this.selectedFilters = [filterKey];
        this.googleAnalyticsService.filterAIDemos(filterKey);
      }
      this.filterPanelData();
    }
  }
  filterPanelData(): void {
    const allDemos: any[] = [];
    const categories = this.aiDemoTitleArray?.[0]?.aiDemoCategory || [];
    // Copilot generated code start
    for (const category of categories) {
      for (const item of category.titleArray) {
        allDemos.push({
          ...item,
          tileBadgeUrl:item.tileBadgeUrl?.replace('.png', '.svg'),
          imgUrl:this.isWildCatLakeStd ? item.imgUrl?.replace('.png', '.svg') : item.imgUrl,
          category: category.category,
          categoryLabel: category.tr_tile
        });
      }
    }
    // Copilot generated code end
    this.filteredPanelData = this.selectedFilters.length === 0 ? allDemos : allDemos.filter((demo: any) => this.selectedFilters.includes(demo.category));
  }

  async routeToDetails(link: string) {
    if (!link) return;
    this.videoLink = link.replace('[XX]', this.language);
    this.modalService.open(this.AIModal, { centered: true, windowClass: 'AI_popup AI_demo_videos', backdrop: 'static', backdropClass: 'ai-default-backdrop-class' });
    this.modalVideoCtrls();
  }

  modalVideoCtrls() {
    const video: HTMLVideoElement = document.getElementById('aiVideo') as HTMLVideoElement;
    video.classList.add('custom-video');
  }

  dismissAIVideoPanel() {
    this.endAi = false;
    this.googleAnalyticsService.checkVideoDismissal();
    this.modalService.dismissAll(this.AIModal)
  }

  playPauseAIVideo(action: EVideoAction) {
    let aiVideoRef = document.getElementById('aiVideo');
    switch (action) {
      case EVideoAction.play:
        this.onPlayAiVideo(aiVideoRef);
        break;
      case EVideoAction.pause:
        this.videoAiPaused(aiVideoRef)
        break;
      case EVideoAction.complete:
        this.endedAiVideo(aiVideoRef)
        break;
    }
  }
  
  onPlayAiVideo(video) {
    let videoName;
    this.endAi = false;
    videoName = this.videoNameForGA(video)

    if (typeof video === 'string') {
      video = document.getElementById(video);
    }
    this.googleAnalyticsService.playVideoGA4(videoName, video?.duration || 0, video?.currentTime);
  }

  endedAiVideo(video) {
    let videoName;
    this.endAi = true;
    videoName = this.videoNameForGA(video);

    if (typeof video === 'string') {
      video = document.getElementById(video);
    }
    this.googleAnalyticsService.completedVideoGA4(videoName, video?.duration || 0);
  }

  videoNameForGA(video) {
    let videoSplit = video?.currentSrc.split("/");
    let videoFileUrlName = videoSplit[videoSplit.length - 1].split('.')[0];
    let videoName = "AiDemo-" + videoFileUrlName + "-" + this.language;
    return videoName;
  }

  videoAiPaused(video) {
    let videoName = this.videoNameForGA(video);
    const videoDuration = video?.duration || 0;
    const currentTime = video?.currentTime || 0;
    if (currentTime > 0 && videoDuration > 0 && currentTime < videoDuration) {
      if (typeof video === 'string') {
        video = document.getElementById(video);
      }
      this.googleAnalyticsService.pauseVideoGA4(videoName, videoDuration, currentTime);
    }
  }

  ngOnDestroy(): void {
    const fontDirectionEl = document.getElementById('fontDirection');
    if (fontDirectionEl) {
      fontDirectionEl.classList.remove('hide-scrollbar');
    }
  }
}
